module.exports = __webpack_public_path__ + "img/logo2.4e862097.png";